import { Injectable } from '@angular/core';
import {RequestService} from "../request/request.service";
import {UtilService} from "../util/util.service";

export enum PermissionActionType {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete"
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private requestService: RequestService,
              private utilService: UtilService) { }

  async evaluateUser(tableIdOrName: string, permissionActionType: PermissionActionType): Promise<boolean> {
    try {
      let tableId = this.getTableId(tableIdOrName);

      const result: any = await this.requestService.createRequest()
        .controller("servicely.core.Permissions")
        .method("evaluateSimpleUserPermission")
        .data({
          table: tableId,
          actionType: permissionActionType
        })
        .execute();

      return result?.data?.permitted ?? false;
    } catch (e) {
      return false;
    }
  }

  private getTableId(idOrName: string): string {
    let id = idOrName;
    if (idOrName != null && !UtilService.isID(idOrName)) {
      const record = (window as any).TableManager.getTableDefinition(idOrName);
      if (record) {
        id = record.getID();
      }
    }
    return id;
  }
}
